/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, current: NonNullable<unknown>, max: NonNullable<unknown> }} Sub_Downgrade_Remove_MembersInputs */



/**
* | output |
* | --- |
* | "Remove {count} member(s) ({current} of {max} max on Starter)" |
*
* @param {Sub_Downgrade_Remove_MembersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_downgrade_remove_members = /** @type {((inputs: Sub_Downgrade_Remove_MembersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Downgrade_Remove_MembersInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Mitglied(er) entfernen (${i?.current} von ${i?.max} max. bei Starter)`)
	return /** @type {LocalizedString} */ (`Remove ${i?.count} member(s) (${i?.current} of ${i?.max} max on Starter)`)
});